/*
 * Public API Surface of mdg-pivot
 */

export * from './lib/mdg-pivot.component';
export * from './lib/mdg-pivot.module';
